import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("be_admin_token", data.token);
      toast.success("Welcome back, pitmaster.");
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    }
    setLoading(false);
  };

  return (
    <div data-testid="admin-login-page" className="max-w-md mx-auto px-6 py-24">
      <div className="border border-ink-600 bg-ink-800 p-8">
        <Lock className="text-brand" size={28} />
        <h1 className="font-display text-4xl text-cream mt-4 leading-none">ADMIN ACCESS</h1>
        <p className="text-[#A19D94] mt-2 text-sm">Pitmaster login only.</p>

        <form onSubmit={submit} className="mt-8 space-y-5">
          <div>
            <label className="block text-xs tracking-[0.25em] text-[#A19D94] mb-2 uppercase">Email</label>
            <input
              required
              type="email"
              data-testid="admin-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-ink-900 border border-ink-600 text-cream px-4 py-3 focus:border-brand focus:outline-none"
            />
          </div>
          <div>
            <label className="block text-xs tracking-[0.25em] text-[#A19D94] mb-2 uppercase">Password</label>
            <input
              required
              type="password"
              data-testid="admin-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-ink-900 border border-ink-600 text-cream px-4 py-3 focus:border-brand focus:outline-none"
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full h-12 bg-brand hover:bg-brand-hover text-ink-900 font-display text-xl tracking-widest disabled:opacity-50 transition-all"
          >
            {loading ? "..." : "LOG IN"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
